// src/components/AboutSection.jsx
import React from "react";

function AboutSection() {
  return (
    <section className="about-section">

      <div className="about-container">

        <h2 className="about-title">Our Story</h2>



        <p>
          At Namaste Restaurant & Bar, we bring the authentic flavours of
          <strong> India and Nepal</strong> to Chatham. Our chefs craft each
          dish with love, tradition, and modern culinary techniques.
        </p>
        {/* Optional divider (place file in /public/about-divider.png) */}
<img src="/menu/thali.png" className="about-divider animate-on-scroll" alt="" />

        <p>
          From sizzling tandoori dishes to comforting Nepalese Momos, we offer
          a menu that blends rich heritage with contemporary taste.
        </p>
      </div>

    </section>
  );
}

export default AboutSection;
